package com.merkost.handpass.admin.container

import com.merkost.handpass.admin.contract.ToastEntry
import com.merkost.handpass.admin.contract.ToastHostAction
import com.merkost.handpass.admin.contract.ToastHostIntent
import com.merkost.handpass.admin.contract.ToastHostState
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import pro.respawn.flowmvi.api.Container
import pro.respawn.flowmvi.dsl.lazyStore
import pro.respawn.flowmvi.plugins.recover
import pro.respawn.flowmvi.plugins.reduce

class ToastHostContainer : Container<ToastHostState, ToastHostIntent, ToastHostAction> {

    private val scope = MainScope()

    private var nextId = 0L
    private val exitMs = 240L
    private val undoCallbacks = mutableMapOf<Long, () -> Unit>()

    override val store by lazyStore(ToastHostState(), scope) {
        configure { name = "ToastHostStore" }
        recover { _ -> null }
        reduce { intent ->
            when (intent) {
                is ToastHostIntent.Show -> {
                    val id = nextId++
                    val entry = ToastEntry(id = id, message = intent.message, kind = intent.kind)
                    updateState { copy(entries = entries + entry) }
                    scope.launch {
                        delay(entry.durationMs.toLong())
                        updateState { copy(entries = entries.map { if (it.id == id) it.copy(exiting = true) else it }) }
                        delay(exitMs)
                        updateState { copy(entries = entries.filterNot { it.id == id }) }
                    }
                }
                is ToastHostIntent.ShowWithAction -> {
                    val id = nextId++
                    undoCallbacks[id] = intent.onAction
                    val entry = ToastEntry(
                        id = id,
                        message = intent.message,
                        kind = intent.kind,
                        actionLabel = intent.actionLabel,
                        durationMs = intent.durationMs,
                    )
                    updateState { copy(entries = entries + entry) }
                    scope.launch {
                        delay(entry.durationMs.toLong())
                        undoCallbacks.remove(id)
                        updateState { copy(entries = entries.map { if (it.id == id) it.copy(exiting = true) else it }) }
                        delay(exitMs)
                        updateState { copy(entries = entries.filterNot { it.id == id }) }
                    }
                }
                is ToastHostIntent.InvokeAction -> {
                    undoCallbacks.remove(intent.id)?.invoke()
                    scope.launch {
                        updateState { copy(entries = entries.map { if (it.id == intent.id) it.copy(exiting = true) else it }) }
                        delay(exitMs)
                        updateState { copy(entries = entries.filterNot { it.id == intent.id }) }
                    }
                }
                is ToastHostIntent.Dismiss -> {
                    undoCallbacks.remove(intent.id)
                    scope.launch {
                        updateState { copy(entries = entries.map { if (it.id == intent.id) it.copy(exiting = true) else it }) }
                        delay(exitMs)
                        updateState { copy(entries = entries.filterNot { it.id == intent.id }) }
                    }
                }
            }
        }
    }
}
